module.exports = __webpack_public_path__ + "media/images/iconbox/icon1-7fec7fa0164955f2031ec099daa00362.png";